import classNames from 'classnames';
import * as React from 'react';

import Icon from '../icons/Icon';

import css from './FavoriteButton.module.scss';

interface Props {
  className?: string;
  count?: number;
  isDisabled?: boolean;
  isFavorite?: boolean;
  onClick?: () => void;
}

class FavoriteButton extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick() {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
  }

  public render() {
    const { className, count, isDisabled, isFavorite } = this.props;
    const classes = classNames(css.FavoriteButton, className);
    const iconClasses = classNames(css.FavoriteButton__Icon, {
      [css.isFavorite]: isFavorite,
    });

    return (
      <button
        className={classes}
        disabled={isDisabled}
        onClick={this.handleClick}
        type="button"
      >
        <Icon name="heart-outline" className={iconClasses} />
        {count !== undefined && (
          <span className={css.FavoriteButton__Count}>{count}</span>
        )}
      </button>
    );
  }
}

export default FavoriteButton;
